import React, { useState, useEffect } from 'react';
import { Select, Space } from 'antd';
import CategoryServices from 'services/product_category';
import { useApp } from "contexts/app";
import _, { values } from "lodash"
import { toSearchText } from 'utils/text';

const service = new CategoryServices();
const CategoryPicker = (props) => {




    const [options, setOptions] = useState([])

    useEffect(() => {
        loadData();
    }, [])

    const loadData = async () => {
        var list = await service.list();
        list = list.map(x => ({ label: x.name, value: x.id, searchText: toSearchText(x.name || '') }))
        setOptions(list)
    }


    return (
        <Select
            {...props}
            allowClear
            showSearch
            optionFilterProp='label'
            filterOption={(input, option) => {
                const inputSearchText = toSearchText(input || '');
                const optionSearchText = option?.searchText || toSearchText(option?.label || '');
                return optionSearchText.includes(inputSearchText);
            }}
            options={options}
        />
    )


}
export default CategoryPicker;